export default {
  data() {
    return {
      formError: {},
    };
  },

  methods: {
    prepareHttpError(error) {
      const response = error.response;
      if (response.data.error_code === 'validation') {
        this.formError = response.data.error_data;
      } else {
        throw error;
      }
    },

    hasFormError(field) {
      return typeof this.formError[field] !== 'undefined';
    },

    getFormError(field) {
      return this.formError[field].join('. ');
    },

    clearFormErrors() {
      this.formError = {};
    },
  },
};
